import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { ProjectPanelPreviewComponent } from '@project-modules/project-preview/components/project-panel-preview/project-panel-preview.component';
import { ProjectPreviewResolver } from '@project-modules/project-preview/components/project-preview.resolver';
import { TaskType } from '@shared/enums/task-type.enum';

export const ProjectPreviewRoutes: CustomRoutes = [
  {
    path: ':projectId',
    component: ProjectPanelPreviewComponent,
    name: 'project-preview',
    resolve: {
      project: ProjectPreviewResolver
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'summary'
      },
      {
        path: 'summary',
        name: 'project-preview-summary',
        data: {
          metaTitle: 'Projects.summary'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-summary/project-summary.module`).then(
            (m) => m.ProjectSummaryModule
          )
      },
      {
        path: 'calendar',
        name: 'project-preview-calendar',
        data: {
          metaTitle: 'Projects.calendar',
          actionButtonText: 'Projects.newEvent',
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-calendar/project-calendar.module`).then(
            (m) => m.ProjectCalendarModule
          )
      },
      {
        path: 'mailings',
        name: 'project-preview-email',
        data: {
          metaTitle: 'Projects.summary'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-email/project-email.module`).then((m) => m.ProjectEmailModule)
      },
      {
        path: 'tasks',
        name: 'project-preview-tasks',
        data: {
          metaTitle: 'Projects.tasks',
          type: TaskType.TYPE_TASK,
          notRestorationPosition: true,
          actionButtonText: 'Projects.new.' + TaskType.TYPE_TASK,
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-tasks/project-tasks.module`).then((m) => m.ProjectTasksModule)
      },

      {
        path: 'orders',
        name: 'project-orders',
        data: {
          metaTitle: 'Projects.orders',
          type: TaskType.TYPE_ORDER,
          notRestorationPosition: true,
          actionButtonText: 'Projects.new.' + TaskType.TYPE_ORDER,
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-tasks/project-tasks.module`).then((m) => m.ProjectTasksModule)
      },
      {
        path: 'corrections',
        name: 'project-corrections',
        data: {
          metaTitle: 'Projects.corrections',
          type: TaskType.TYPE_CORRECTION,
          notRestorationPosition: true,
          actionButtonText: 'Projects.new.' + TaskType.TYPE_CORRECTION,
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-tasks/project-tasks.module`).then((m) => m.ProjectTasksModule)
      },
      {
        path: 'team',
        name: 'project-preview-team',
        data: {
          metaTitle: 'Projects.team',
          notRestorationPosition: false,
          actionButtonText: 'ProjectTeam.addNewTeamMember',
          actionButtonIcon: './assets/img/ic_plus_contact_white.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-team/project-team.module`).then((m) => m.ProjectTeamModule)
      },
      {
        path: 'contacts',
        name: 'project-preview-contacts',
        data: {
          metaTitle: 'Projects.contacts',
          notRestorationPosition: false,
          actionButtonText: 'ProjectContacts.addNewContact',
          actionButtonIcon: './assets/img/ic_plus_contact_white.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-contacts/project-contacts.module`).then(
            (m) => m.ProjectContactsModule
          )
      },
      {
        path: 'configurator',
        name: 'project-configurator',
        data: {
          metaTitle: 'Projects.projectConfigurator',
          notRestorationPosition: true
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/projects-configurator/projects-configurator.module`).then(
            (m) => m.ProjectsConfiguratorModule
          )
      },
      {
        path: 'changes',
        name: 'project-preview-changes',
        data: {
          metaTitle: 'Projects.changes',
          notRestorationPosition: false,
          actionButtonText: 'ProjectChanges.newChange',
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-changes/project-changes.module`).then(
            (m) => m.ProjectChangesModule
          )
      }
    ]
  }
];
